import { useState } from 'react'
import { Stack } from 'react-bootstrap'
import { useCSVReader } from 'react-papaparse'
import upload from '../../../_metronic/images/FileUpload.svg'
type uploadCSV = {
  btnDisabled?: boolean
  setBtnDisabled?: any
  fileUploadErr: boolean
  setFileUploadErr: any
  setManualDisable?: any
  arrayHelpers: any
  setIsSubmit: any
  leaders: any
  activeStatus: boolean
}
const UploadAgentCSV = ({
  btnDisabled,
  setBtnDisabled,
  fileUploadErr,
  setFileUploadErr,
  setManualDisable,
  arrayHelpers,
  setIsSubmit,
  leaders,
  activeStatus
}: uploadCSV) => {
  const [csvValidationMsg, setCsvValidationMsg] = useState<string>('')
  const [validationMsg, setValidationMsg] = useState<string>('')
  const [uplodingMessage, setUplodingMessage] = useState(false)
  const { CSVReader } = useCSVReader()
  const validLeaderCodes = leaders.map((l: any) => l.leaderCode)
  return (
    <div className='upload-section'>
      <CSVReader
        maxFiles={1}
        accept='.csv'
        onUploadAccepted={async (results: any) => {
          // setFileUploadErr(true)
          let canUpload = true
          setValidationMsg('')
          setManualDisable && setManualDisable(true)

          // Check if CSV contains no data
          if (results.data.length === 0) {
            setBtnDisabled && setBtnDisabled(true)
            setValidationMsg('Please upload valid data')
            canUpload = false
          }

          // Ensure that the first row has the correct headers
          const columnName = Object.keys(results.data[0])

          if (activeStatus) {
            // EMAIL FLOW
            if (
              columnName.length !== 5 ||
              columnName[0] !== 'Agent First Name' ||
              columnName[1] !== 'Agent Last Name' ||
              columnName[2] !== 'Agent Email ID' ||
              columnName[3] !== 'Agent Leader Code' ||
              columnName[4] !== 'Agent Rep Id'
            ) {
              canUpload = false
              setCsvValidationMsg('Headers are mismatched. Please upload a valid Email CSV format')
              setBtnDisabled && setBtnDisabled(true)
              return
            }
          } else {
            if (
              columnName.length !== 6 ||
              columnName[0] !== 'Agent First Name' ||
              columnName[1] !== 'Agent Last Name' ||
              columnName[2] !== 'Agent User Name' ||
              columnName[3] !== 'Agent Password' ||
              columnName[4] !== 'Agent Leader Code' ||
              columnName[5] !== 'Agent Rep Id'
            ) {
              canUpload = false
              setCsvValidationMsg('Headers are mismatched. Please upload a valid Username CSV format')
              setBtnDisabled && setBtnDisabled(true)
              return
            }
          }

          // Check if mandatory fields are non-empty for each row
          results.data.forEach((agent: any, index: number) => {
            if (
              !agent['Agent First Name'] ||
              !agent['Agent Last Name']
            ) {
              canUpload = false
              setBtnDisabled && setBtnDisabled(true)
              setCsvValidationMsg(`Row ${index + 1}: Please ensure all mandatory fields are filled`)
              return
            }

            if (activeStatus) {
              // EMAIL FLOW
              const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
              const email = agent['Agent Email ID']?.trim()

              if (!email || !emailPattern.test(email)) {
                canUpload = false
                setBtnDisabled && setBtnDisabled(true)
                setCsvValidationMsg(`Row ${index + 1}: Invalid email format`)
                return
              }
            } else {
              // USERNAME PASSWORD FLOW
              const username = agent['Agent User Name']
              const password = agent['Agent Password']

              const usernamePattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z0-9]{7,}$/;
              const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d])[A-Za-z\d`~!@#$%^&*()_+=\-{}|[\]:;"'<>,.?\/]{8,}$/;

              if (!username || !usernamePattern.test(username)) {
                canUpload = false
                setBtnDisabled && setBtnDisabled(true)
                setCsvValidationMsg(`Row ${index + 1}: Invalid username format. Username must contain at least 7 characters, including one uppercase letter, one lowercase letter, and one number. (Example: TpvSolutions123)`)
                return
              }

              if (!password || !passwordPattern.test(password)) {
                canUpload = false
                setBtnDisabled && setBtnDisabled(true)
                setCsvValidationMsg(`Row ${index + 1}: Invalid password format. Password must follow the rules: at least one uppercase, one lowercase, one number, and one symbol (Example: TpvSolutions@123)`)
                return
              }
            }

            if (
              agent['Agent Leader Code'] &&
              !validLeaderCodes.includes(agent['Agent Leader Code'])
            ) {
              canUpload = false
              setBtnDisabled && setBtnDisabled(true)
              setCsvValidationMsg(`Row ${index + 1}: Invalid Agent Leader Code`)
              return
            }
          })
          if (canUpload) {
            const agentData = results?.data

            const cleanedAgentData = agentData?.map((agent: any) => {
              if (activeStatus) {
                // EMAIL FLOW
                return {
                  agentFirstName: agent['Agent First Name']?.trim(),
                  agentLastName: agent['Agent Last Name']?.trim(),
                  agentEmailID: agent['Agent Email ID']?.trim(),
                  agentLeaderCode: agent['Agent Leader Code']?.trim() || null,
                  agentRepId: agent['Agent Rep Id']?.trim(),
                  UserName: '',
                  agentPassword: '',
                }
              } else {
                // USERNAME PASSWORD FLOW
                return {
                  agentFirstName: agent['Agent First Name']?.trim(),
                  agentLastName: agent['Agent Last Name']?.trim(),
                  UserName: agent['Agent User Name']?.trim(),
                  agentPassword: agent['Agent Password']?.trim(),
                  agentLeaderCode: agent['Agent Leader Code']?.trim() || null,
                  agentRepId: agent['Agent Rep Id']?.trim(),
                  agentEmailID: '',
                }
              }
            })

            cleanedAgentData?.forEach((item: any) => {
              arrayHelpers.push({ ...item })
            })

            typeof setIsSubmit === 'function' && setIsSubmit(true)
            setValidationMsg('')
            setCsvValidationMsg('')
            setUplodingMessage(true)
          }
        }}
        onUploadRejected={async (file: any) => {
          const tempError: any = file[0]?.errors[0]
          if (tempError.code === 'file-invalid-type') {
            setCsvValidationMsg('')
            setFileUploadErr(true)
          }
        }}
        config={{ header: true, delimiter: ',', skipEmptyLines: true }}
        onDragOver={(event: DragEvent) => {
          event.preventDefault()
        }}
        onDragLeave={(event: DragEvent) => {
          event.preventDefault()
        }}
      >
        {({ getRootProps, acceptedFile, ProgressBar, getRemoveFileProps, Remove }: any) => (
          <>
            <div {...getRootProps()}>
              <>
                {acceptedFile ? (
                  <>
                    {uplodingMessage ? (
                      <div className='text-center'>
                        {!validationMsg && (
                          <label className='uploaded-label'>File uploaded successfully</label>
                        )}
                      </div>
                    ) : validationMsg ? (
                      <>
                        <p className='mt-1 text-danger'>Please upload valid data</p>
                        <Stack gap={2} className='align-items-center justify-content-center'>
                          <img
                            src={upload}
                            alt=''
                            width='40'
                            height='40'
                            className='svg-icon svg-icon-1'
                          />
                        </Stack>
                        <span className='text-muted fw-semibold text-muted d-block fs-7 text-center'>
                          Upload CSV
                        </span>
                      </>
                    ) : (
                      <>
                        <p className='mt-1 text-danger'>{csvValidationMsg}</p>
                        <Stack gap={2} className='align-items-center justify-content-center'>
                          <img
                            src={upload}
                            alt=''
                            width='40'
                            height='40'
                            className='svg-icon svg-icon-1'
                          />
                        </Stack>
                        <span className='text-muted fw-semibold text-muted d-block fs-7 text-center'>
                          Upload CSV
                        </span>
                        {fileUploadErr && (
                          <label className='uploaded-label err-label'>
                            Please upload the CSV file.
                          </label>
                        )}
                      </>
                    )}
                  </>
                ) : (
                  <>
                    <Stack gap={2} className='align-items-center justify-content-center'>
                      <img
                        src={upload}
                        alt=''
                        width='40'
                        height='40'
                        className='svg-icon svg-icon-1'
                      />
                      <span className='text-dark text-hover-primary fs-6'>
                        Drop files here or click to upload
                      </span>
                      <span className='text-muted fw-semibold text-muted d-block fs-7'>
                        Upload CSV
                      </span>
                      {!acceptedFile && fileUploadErr && (
                        <label className='uploaded-label err-label'>
                          Please upload the CSV file.
                        </label>
                      )}
                    </Stack>
                  </>
                )}
              </>
            </div>
          </>
        )}
      </CSVReader>
    </div>
  )
}
export default UploadAgentCSV
